export const LLM_VERSIONS = {
    FAST: {
        value: 'gpt-4o-mini',
        name: 'Fast',
        description: 'Faster results for simpler tasks',
    },
    DEEP: {
        value: 'gpt-4o',
        name: 'Deep',
        description: 'Slower, but more powerful results for complex tasks',
    },
}

export const LLM_VERSIONS_VALUE_TO_NAME = {
    [LLM_VERSIONS.FAST.value]: [LLM_VERSIONS.FAST.name],
    [LLM_VERSIONS.DEEP.value]: [LLM_VERSIONS.DEEP.name],
}

export const LLM_VERSIONS_VALUE_TO_DESCRIPTION = {
    [LLM_VERSIONS.FAST.value]: [LLM_VERSIONS.FAST.description],
    [LLM_VERSIONS.DEEP.value]: [LLM_VERSIONS.DEEP.description],
}

export const getLlmVersionName = value => {
    return LLM_VERSIONS_VALUE_TO_NAME[value] || value
}

export const getLlmVersionDescription = value => {
    return LLM_VERSIONS_VALUE_TO_DESCRIPTION[value] || 'No description'
}
